import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/lib/useQuery/queryKeys";
import { addQuestionWithQuestionBankIfNeeded } from ".";

export function useAddQuestion(){
    const queryClient = useQueryClient()

    return useMutation({
        mutationKey: queryKeys.question._def,
        mutationFn: addQuestionWithQuestionBankIfNeeded,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.question._def, exact: false });
        }
    });
}
